<template>
    <Form
        ref="info"
        :model="info"
        :rules="ruleValidate"
        :label-width="100"
        :viewonly="viewonly"
    >
        <Row :gutter="20">
            <Col span="8">
                <FormItem prop="period" label="期数">
                    <input-number
                        v-model="info.period"
                        placeholder
                        :allowDecimal="false"
                        :max="monthNum"
                        :min="1"
                    />
                </FormItem>
            </Col>
            <Col span="16">
                <div class="title">
                    <span class="red">共{{ monthNum }}个月</span>
                    <span v-if="viewonly"></span>
                </div>
            </Col>
        </Row>
        <template v-if="info.period">
            <field-group
                v-for="(item, index) in intervalList"
                :key="index"
                :model="item"
            >
                <Row :gutter="20">
                    <Col span="10">
                        <FormItem prop="month" :label="`第${index + 1}期`">
                            <span>第 </span>
                            <input-number
                                v-model="item.first"
                                placeholder
                                :allowDecimal="false"
                                :max="monthNum"
                                :min="1"
                                disabled
                                style="width: 50px"
                            />
                            <span> 个月</span>
                            <span> - 第 </span>
                            <input-number
                                v-model="item.last"
                                placeholder
                                :allowDecimal="false"
                                :max="item.max"
                                :min="1"
                                style="width: 50px"
                                :disabled="
                                    info.period == 1 || item.last == monthNum
                                "
                                @on-focus="valFocus"
                                @on-blur="valBlur(index, item.last)"
                            />
                            <span> 个月</span>
                        </FormItem>
                    </Col>
                    <Col span="14" v-if="!viewonly">
                        <div class="title">
                            请输入{{
                                item.first - 0 + 1 > item.max
                                    ? item.max
                                    : item.first - 0
                            }}-{{ item.max }}的整数
                        </div>
                    </Col>
                    <Col span="24">
                        <div class="month">
                            <span
                                v-for="(son, sonIndex) in periodList[index]"
                                :key="`${index}-${sonIndex}`"
                                >第{{ son.period }}个月({{ son.startDate }} 至
                                {{ son.endDate }})
                            </span>
                        </div>
                    </Col>
                </Row>
            </field-group>
        </template>
    </Form>
</template>
<script>
import { deepCopy, ymd } from '_u/helper'
import { queryDefinedPeriods } from '@/api/bill'

export default {
    name: 'RentCustomForm',

    props: {
        startDate: {
            type: [String],
            default: '',
        },
        endDate: {
            type: [String],
            default: '',
        },
        viewonly: {
            type: [Boolean],
            default: false,
        },
        mergeList: {
            type: [String],
            default: '',
        },
    },

    components: {},

    inject: {
        $modal: {
            default: null,
        },
    },

    data() {
        return {
            periodList: [],
            monthList: [1, 2, 3, 4, 5],
            intervalList: [], //区间
            info: {
                period: '',
            },
            currentValue: '', //当前聚焦输入框的值
        }
    },
    computed: {
        ruleValidate() {
            const validateMonth = (rule, value, callback, source) => {
                console.log(source)
                value = parseInt(value)
                const num =
                    source.first - 0 + 1 > source.max
                        ? source.max
                        : source.first - 0

                if (value >= num && value <= source.max) {
                    callback()
                } else {
                    callback(new Error(`输入的范围要在${num}-${source.max}`))
                }
            }
            return this.viewonly
                ? {}
                : {
                      period: [{ required: true, message: '期数必填' }],
                      month: [
                          { required: true, message: '月数必填' },
                          { validator: validateMonth },
                      ],
                  }
        },
        monthNum() {
            return this.monthList.length
        },
    },
    watch: {
        'info.period'(val) {
            if (this.viewonly) {
                return
            }
            val -= 0
            let first = 0
            let other = 0
            const arr = []
            if (!val) {
                first = 0
                other = 0
            } else if (val === 1) {
                first = this.monthNum
                other = 0
                arr.push({ first: 1, last: first, max: this.monthNum })
            } else {
                other = Math.floor(this.monthNum / val)
                first = this.monthNum - other * val + other
                let start = 1
                arr.push({
                    first: start,
                    last: first,
                    max: this.monthNum - val + 1,
                })
                for (let i = 0; i < val - 1; i++) {
                    const item = arr[arr.length - 1]
                    start = item.last + 1
                    arr.push({
                        first: start,
                        last: item.last + other,
                        max: this.monthNum - val + i + 2,
                    })
                }
            }
            this.intervalList = arr
            this.getPeriodList()
        },
    },
    mounted() {
        var $info = this.$refs.info

        // 按钮配置
        var btns = [{ type: 'default', text: '取消', name: 'cancel' }]

        if (this.$can('update') && !this.viewonly) {
            btns.unshift({
                type: 'primary',
                name: 'confirm',
                text: '确定',
            })
        }
        this.$modal.updateBtns(btns)

        // 预加载
        this.$modal.beforeEnter((next) => {
            Promise.all([this.fetch()])
                .then((args) => {
                    var [view] = args

                    if (view) {
                        this.monthList = view.data.periodList || []

                        if (this.viewonly) {
                            const intervalList = []
                            const mergeList = JSON.parse(this.mergeList)
                            mergeList.forEach((v) => {
                                intervalList.push({
                                    first: v.startPeriod, // 开始账期
                                    last: v.endPeriod, // 结束账期
                                })
                            })
                            this.info.period = mergeList.length
                            this.intervalList = intervalList
                            this.getPeriodList()
                        }
                    }
                })
                .finally(() => {
                    next()
                })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            $info
                .validate()
                .then((res) => {
                    const mergeList = []
                    this.intervalList.forEach((v, i) => {
                        mergeList.push({
                            period: i + 1, // 期数
                            startPeriod: v.first, // 开始账期
                            endPeriod: v.last, // 结束账期
                        })
                    })
                    this.$emit('on-confirm', mergeList)
                    this.$Message.success('成功设置自定义账期')
                })
                .catch((err) => {
                    options.closeModal = false
                })
                .finally(() => {
                    next()
                })
        })
    },
    methods: {
        fetch() {
            return queryDefinedPeriods({
                startDate: this.startDate,
                endDate: this.endDate,
            })
        },
        getPeriodList() {
            const arr = this.intervalList
            const periodList = []
            arr.forEach((v) => {
                periodList.push(
                    this.monthList.slice(
                        parseInt(v.first) - 1,
                        parseInt(v.last)
                    )
                )
            })
            this.periodList = periodList
        },
        valFocus(event) {
            this.currentValue = parseInt(event.target.value)
        },
        valBlur(index, value) {
            if (this.currentValue === parseInt(value)) {
                // 没有更改
                return
            }
            const len = this.intervalList.length
            for (let i = index + 1; i < len; i++) {
                const item = this.intervalList[i]
                const beforeItem = this.intervalList[i - 1]
                item.first = parseInt(beforeItem.last) + 1
                if (i < len - 1) {
                    const last = parseInt(item.first) + 1
                    item.last = last > item.max ? item.max : last
                }
                item.num = item.last - item.first + 1
            }
            this.getPeriodList()
        },
    },
}
</script>
<style lang="less" scoped>
.title {
    line-height: 30px;
    color: #7f7f7f;
    .red {
        color: red;
        margin-right: 5px;
    }
}
.month {
    display: flex;
    flex-wrap: wrap;
    padding-left: 100px;
    position: relative;
    top: -5px;
    span {
        width: 230px;
        border: 1px solid #e3e3e3;
        background: #f7f7f7;
        color: #909090;
        text-align: center;
        padding: 2px;
        margin: 0px 10px 10px 0px;
        border-radius: 5px;
    }
}
</style>
